import { render, staticRenderFns } from "./ApproverForm.vue?vue&type=template&id=2578525d&scoped=true&"
import script from "./ApproverForm.vue?vue&type=script&lang=js&"
export * from "./ApproverForm.vue?vue&type=script&lang=js&"
import style0 from "./ApproverForm.vue?vue&type=style&index=0&id=2578525d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578525d",
  null
  
)

export default component.exports